import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import { createStore } from 'vuex'


let store = {
    state,
    getters,
    actions,
    mutations,
}

export default createStore(store)
